/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetGraphicsPackageRequest} from '@cash-web/protos/squareup/cash/taply/app/v1beta1/get_graphics_package_app.pb'
import {GetGraphicsPackageResponse} from '@cash-web/protos/squareup/cash/taply/app/v1beta1/get_graphics_package_app.pb'


export const getGraphicsPackage = (request: GetGraphicsPackageRequest, options?: CashRequestOptions) => post<GetGraphicsPackageRequest, GetGraphicsPackageResponse>("/cash-app/taply/v1.0/get-graphics-package", request, {...options, rejectOnError: true })